import { useRef } from 'react';

export default () => {
  const ref = useRef<HTMLDivElement>(null);

  return { ref };
};
